module.exports = __webpack_public_path__ + "static/media/instagram-colored.b9f1e06c.svg";